<template>
  <div class="form-group">
    <label
      v-if="titulo != 'hide'"
      v-bind:class="{
        'text-danger':
          current.errors.unidad_medida &&
          current.errors.unidad_medida.length > 0,
      }"
      >{{ titulo }}</label
    >
    <select
      class="form-control"
      v-model="current.unidad_medida"
      @change="onChangeSelect($event)"
    >
      <option
        v-for="(unidad_medida, key) in unidades_medidas"
        :value="unidad_medida.id"
        :key="key"
      >
        {{ unidad_medida.nombre }}
      </option>
    </select>
    <small
      v-if="current.errors && current.errors.unidad_medida"
      class="form-text text-danger"
      >{{ current.errors.unidad_medida[0] }}</small
    >
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    titulo: {
      type: String,
      default: "Unidad Medida",
    },
  },
  computed: {},
  data() {
    return {
      unidades_medidas: [],
    };
  },
  mounted() {
    this.refreshDataUnidadmedidaSolicitud();
  },
  methods: {
    refreshDataUnidadmedidaSolicitud() {
      let self = this;
      DynamicService.fetch("cat", "unidad-medida", {
        quitar_paginacion: true,
      }).then((res) => {
        self.unidades_medidas = res.data;
      });
    },
    onChangeSelect() {
      this.$emit("onchangeselect", event);
    },
  },
};
</script>